module.exports = __webpack_public_path__ + "img/37.fd0ca19a.jpg";